import { RecoverConversationGroupKeySchema } from "@redotech/redo-model/aggregated-metrics/recover-conversation";
import * as z from "zod/v4";

export const recoverAggregatedMetricsSchema = z.object({
  initialSends: z.number(),
  replySends: z.number(),
  customerReplies: z.number(),
  uniqueCustomerReplies: z.number(),
  recoveredOrders: z.number(),
  recoveredRevenue: z.number(),
  unsubscribes: z.number(),
  skippedDueToUnsubscribe: z.number(),
  skippedDueToSkipConditions: z.number(),
  checkoutAbandonments: z.number(),
});

export type RecoverAggregatedMetrics = z.infer<
  typeof recoverAggregatedMetricsSchema
>;

export const getRecoverAggregatedMetrics = {
  name: "getRecoverAggregatedMetrics" as const,
  input: z.object({
    groupBy: RecoverConversationGroupKeySchema,
    metricsStart: z
      .string()
      .optional()
      .describe("Start date for the analytics period (YYYY-MM-DD)"),
    metricsEnd: z
      .string()
      .optional()
      .describe("End date for the analytics period (YYYY-MM-DD)"),
  }),
  output: recoverAggregatedMetricsSchema,
};
